import { render, staticRenderFns } from "./OrderMockForm.vue?vue&type=template&id=1986e7de&scoped=true&"
import script from "./OrderMockForm.vue?vue&type=script&lang=js&"
export * from "./OrderMockForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderMockForm.vue?vue&type=style&index=0&id=1986e7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986e7de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VChip,VCombobox,VDivider,VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSwitch})
